var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataListStateful',{attrs:{"title":"Продавцы","resource":"factories","store":"factories","columns":_vm.columns,"filter-options":_vm.filter}})
}
var staticRenderFns = []

export { render, staticRenderFns }